import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IFetchEvaluationDetailsParams } from '../../../types';

/**
 * This is to track the the query keys for fetching evaluation details of a done
 * evaluation.
 */
const EVALUATION_DETAILS_QUERY_KEY = 'evaluation-details-query-key';

/**
 * React Query mutation function for fetching evaluation details of a done
 * evaluation.
 */
export const useEvaluationDetailsQuery = (
  params: IFetchEvaluationDetailsParams
) => {
  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    queryKey: [EVALUATION_DETAILS_QUERY_KEY, params.evaluationId],
    networkMode: 'always',
    queryFn: () => INBOUND_API.fetchEvaluationDetails(params),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetchEvaluationDetails: refetch,
  };
};
